import { ReportValue } from '../../../Models/ReportValue';

export const isStateReportable = (report: ReportValue): boolean => {
  if (report.reportable && report.reportable.length > 0) {
    return report.reportable[0].is_reportable;
  }
  return true;
};
